import { ENVIRONMENTS } from './config';

export const getEnvironmentByHostname = () => {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return '';
  }

  const hostname = String(window.location.hostname);

  if (hostname.startsWith('tamagotchi.')) {
    return ENVIRONMENTS.prod;
  }

  if (hostname.startsWith('preprod-')) {
    return ENVIRONMENTS.preprod;
  }

  return ENVIRONMENTS.test;
};
